<template>
  <div class="app-checkout-selection">
    <h1><slot name="txtHeadline"></slot></h1>
    <SimonModal
      :is-visible="showSimActivationInfoModal"
      @hide="showSimActivationInfoModal = false"
      id="sim-activated-info-modal"
      size="large"
    >
      <template v-slot:modalTitle>
        <h2><slot name="titleInfoModalSimActivationData"></slot></h2>
      </template>
      <div class="sim-modal-body">
        <b-tabs card pills align="center">
          <b-tab :title="getSlotText('tabInfoModalPreactivatedSimActivationData', 'test')" :active="simActivationPreference === 'PREACTIVATED'">
           <b-card-text><slot name="txtInfoModalPreactivatedSimActivationData"></slot></b-card-text>
          </b-tab>
          <b-tab :title="getSlotText('tabInfoModalCustomerSimActivationData', 'test')" :active="simActivationPreference === 'BY_CUSTOMER'">
            <b-card-text><slot name="txtInfoModalCustomerSimActivationData"></slot></b-card-text>
          </b-tab>
       </b-tabs>
      </div>
    </SimonModal>
    <form>
      <SimSelection :sim-type.sync="simType">
        <template v-for="slot in possibleChildSlotsFor('SimData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SimSelection>
      <div v-if="simType === 'SIM_CARD'" class="sim-type-selection">
        <div class="sim-data--header"><slot name="txtHeadlineActivationSimData">DATA</slot></div>
        <div class="selection-cards">
          <LabeledRadioInput name="simActivated"
                             class="simActivated"
                             :model.sync="simActivationPreference"
                             :label="getSlotText('lblSimActivationData')"
                             first-radio-value="BY_CUSTOMER"
                             second-radio-value="PREACTIVATED"
          >
            <template v-slot:afterLabel><button type="button" @click="trackAndShowSimActivationInfoModal()" :aria-label="getSlotText('infoIconAriaLabelSimActivationData')" class="icon-only"><img src="files/flash/images/svg-icons/info-icon.svg"></button></template>
            <template v-for="slot in possibleChildSlotsFor('SimActivationData')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </LabeledRadioInput>
        </div>
      </div>
    </form>
    <Stepper
      @next="save()"
      @prev="back()"
      :show-prev="true"
    >
      <template v-for="slot in possibleChildSlotsFor('StepperSimData')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>
<script>
import preFilledInput from '@/mixins/preFilledInput'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import Stepper from '@/components/generic/Stepper.vue'
import trackingHandler from '@/mixins/trackingHandler'
import SimSelection from '@/components/checkout/belatedPorting/SimSelection.vue'
import LabeledRadioInput from '@/components/forms/LabeledRadioInput.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'Selection',
  data () {
    return {
      simActivationPreference: '',
      showSimActivationInfoModal: false
    }
  },
  mounted () {
    this.simActivationPreference = this.getSimActivated ? 'PREACTIVATED' : 'BY_CUSTOMER'
  },
  props: {
    backLink: {
      type: String,
      default: 'mein-simon/sim'
    }
  },
  mixins: [
    isValid,
    preFilledInput('simType', 'getSimType'),
    validationFlow,
    trackingHandler
  ],
  components: {
    SimonModal,
    LabeledRadioInput,
    SimSelection,
    Stepper
  },
  watch: {
    simType: {
      handler (newValue) {
        if (newValue) {
          this.setSimType(newValue)
        }
      },
      immediate: true
    }
  },
  methods: {
    setSimType (simType) {
      this.$store.commit('checkoutv2/substituteSim/setSimType', simType)
    },
    setSimActivated (simActivated, simType) {
      if (simType === 'E_SIM') {
        this.$store.commit('checkoutv2/substituteSim/setSimActivated', true)
      } else {
        this.$store.commit('checkoutv2/substituteSim/setSimActivated', simActivated)
      }
    },
    trackAndShowSimActivationInfoModal () {
      this.showSimActivationInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'sim activation info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      this.trackData('information', data)
    },
    back () {
      window.location.href = this.backLink
    },
    save () {
      this.setSimType(this.simType)
      this.setSimActivated(this.simActivationPreference === 'PREACTIVATED', this.simType)
      this.$emit('goForward')
    }
  },
  computed: {
    getSimType () {
      return this.$store.getters['checkoutv2/substituteSim/simType']
    },
    getSimActivated () {
      return this.$store.getters['checkoutv2/substituteSim/simActivated']
    }
  }
}
</script>
